export {};
//# sourceMappingURL=glTFLoaderInterfaces.js.map